import * as React from 'react';
import { createMasonryInstance } from '@leagueplatform/masonry';
import { useParamsLegacy as useParams } from '@leagueplatform/routing';
import {
  PageContainer,
  PageNotFound,
} from '@leagueplatform/web-common-components';
import { useDashboardConfig } from '#hooks/use-dashboard-config.ts';

type Params = {
  dataType: string;
};

export const AllRecordedData = () => {
  const { dataType } = useParams<Params>();
  const { allRecordedDataMasonryConfigKey } = useDashboardConfig();

  const { Component: MasonryComponent } = React.useMemo(
    () => createMasonryInstance(),
    [],
  );

  if (!allRecordedDataMasonryConfigKey) {
    return <PageNotFound />;
  }

  return (
    <PageContainer>
      <MasonryComponent
        rootNodeId={allRecordedDataMasonryConfigKey}
        initialQueryParams={{ metricType: dataType }}
      />
    </PageContainer>
  );
};
